<template>
  <FormTemplate>
    <template #leftAction>
      <NavigationButton :actionClickHandler="leftAction.onClick">
        <template #icon>
          <i class="fas fa-arrow-left"></i>
        </template>
        <template #text>{{ leftAction.text }}</template>
      </NavigationButton>
    </template>
    <template #navigation>
      <general-information-certification ref="generalInfoForm" />
    </template>
  </FormTemplate>
</template>

<script>
import Vue from "vue";
import FormTemplate from "../../../templates/FormTemplate.vue";
import NavigationButton from "../../../components/navigation-button/NavigationButton.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("general-information-certification", () => 
  import("./GeneralInformationCertificationForm.vue")
);

export default {
  components: {
    FormTemplate,
    NavigationButton
  },
  async mounted() {
    if (this.$route.params.id) {
      this.leftAction.text = "Editar Certificado";
    }
  },
  data: function () {
    return {
      leftAction: {
        text: "Novo certificado",
        onClick: this.leftActionClickHandler,
      }
    };
  },
  methods: {
    leftActionClickHandler() {
      const generalInfoForm = this.$refs.generalInfoForm;
      if (generalInfoForm && generalInfoForm.onCancel) {
        generalInfoForm.onCancel();
      } else {
        this.$router.push(RoutesPaths.certificationManagement.rootName());
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.certification-content {
  width: 100%;
  padding: 2rem;
}
</style>
